import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import AllowanceNote from './AllowanceNote/index';
import styles from './serviceButton.module.css';

const ServiceButton = ({ onClick, type, address, service }) => {

  var buttonText = '';
  switch (service) {
    case 1:
      buttonText = 'Book an Appointment';
      break;
    case 2:
      buttonText = 'Request a Prescription';
      break;
    case 3:
      buttonText = 'Login / My Details';
      break;
    default:
      buttonText = 'Test';
      break;
  }

  return (
    <div className={styles.container}>
      {address && (
        <a
          className={styles.directions}
          href={`https://www.google.co.nz/maps/place/${address}`}
        >
          Get Directions
        </a>
      )}
      <button
        className={classnames(
          { [styles.blueButton]: service === 1 || service === 3 },
          { [styles.whiteButton]: service === 2 },
        )}
        id="nw_book"
        onClick={onClick}
      >
        {buttonText}
      </button>
      <AllowanceNote type={type} service={service} />
    </div>
  )
};

ServiceButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  type: PropTypes.number,
  service: PropTypes.number,
  address: PropTypes.string,
};

export default ServiceButton;
